'use client';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import FaIcon from '../../icon/FaIcon/FaIcon';
import ImageView from '../ImageView/ImageView';
import ModalBase from '../ModalBase/ModalBase';
import styles from './ScrollImageModal.module.scss';

export interface ScrollImageModalProps {
  showUrl: string;
  isOpen: boolean;
  close: () => void;
  onNext: () => void;
  onPrev: () => void;
}

function ScrollImageModal({ showUrl, isOpen, close, onNext, onPrev }: ScrollImageModalProps) {
  const componentStyles = styles;

  return (
    <div className={componentStyles.componentStyle}>
      <ModalBase isOpen={isOpen} onClose={close} bgColor='transparent'>
        <div className={componentStyles.contentsContainer}>
          <button type='button' className={componentStyles.navButton} onClick={() => onPrev()}>
            <FaIcon icon={faChevronLeft} />
          </button>
          <ImageView src={showUrl} isFreeSize />
          <button type='button' className={componentStyles.navButton} onClick={() => onNext()}>
            <FaIcon icon={faChevronRight} />
          </button>
        </div>
      </ModalBase>
    </div>
  );
}

export default ScrollImageModal;
